import { FieldNumberOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation';
import React from 'react';
import type { IWidgetType } from '~packages/engine/src/schema/widgets/IWidgetType';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule';
import { IntegerRule } from '../../../../rules/repository/integer/Integer.rule';
import { PositiveRule } from '../../../../rules/repository/positive/Positive.rule';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule';
import { ValueRangeRule } from '../../../../rules/repository/value-range/ValueRange.rule';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema';
import { createCommonFormSchema } from '../common/createCommonFormSchema';
import type { INumberWidget } from './INumberWidget';
import { NumberWidgetComponent } from './NumberWidgetComponent';
import {
  NumberWidgetConfigComponent,
  NumberWidgetConfigSchema,
} from './NumberWidgetConfigComponent';

export const NumberWidgetType: IWidgetType<INumberWidget> = {
  type: WidgetType.Number,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  name: 'Campo numerico',
  icon: <FieldNumberOutlined />,
  hasValue: true,
  getReference: getSimpleWidgetReference(Datatype.Number),
  formComponent: NumberWidgetComponent,
  createFormSchema: ({ widget }) =>
    // TODO al momento i gli input impostano null all'onClear, dando problemi di validazione ai campi opzionali (non nullabili di default).
    // Utilizzare gli undefined come valori per l'onClear on sembra immediato a causa della gestione dei valori negli input di antd.
    createCommonFormSchema(yup.number().notRequired(), widget),
  previewComponent: NumberWidgetComponent,
  configValidator: NumberWidgetConfigSchema,
  configComponent: NumberWidgetConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  rules: [
    RequiredRule,
    ValueRangeRule,
    IntegerRule,
    PositiveRule,
    CustomWarningsRule,
  ],
};
